import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';

/** Texto curto do efeito de "Marcar como teste", reaproveitado nos tooltips. */
export const MARK_TEST_HINT =
  'Empresa de teste tem checkout gratuito no Stripe (cupom de 100%). Todo checkout gratuito é auditado por e-mail.';

/** A empresa 0 nunca vira teste (o servidor também recusa, set_test.php). */
export const COMPANY_ZERO_TEST_HINT =
  'A empresa 0 é a conta principal da plataforma e não pode ser marcada como teste.';

/** "Marcar como teste" fica disponível, exceto para a empresa 0 (desmarcar sempre pode). */
export function canMarkCompanyTest(id, isTest) {
  return Number(id) !== 0 || Number(isTest) === 1;
}

/**
 * MarkCompanyTestDialog - Confirmação antes de marcar uma empresa como teste (Admin Geral)
 *
 * Marcar como teste libera o checkout gratuito no Stripe (cupom de 100%) e
 * permite excluir a empresa. Desmarcar não passa por aqui.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {{ id: number|string, name: string }|null} props.company
 * @param {boolean} props.loading
 * @param {Function} props.onConfirm
 * @param {Function} props.onCancel
 */
function MarkCompanyTestDialog({ isOpen, company, loading, onConfirm, onCancel }) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Marcar empresa como teste"
      variant="warning"
      confirmLabel="Marcar como teste"
      cancelLabel="Cancelar"
      onConfirm={onConfirm}
      onCancel={onCancel}
      loading={loading}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {company?.name && (
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
            {company.name}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Uma empresa de teste tem <strong>checkout gratuito no Stripe</strong>: o cupom de 100% é
          aplicado a toda assinatura contratada por ela.
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Todo checkout gratuito é auditado: um e-mail de alerta é enviado aos administradores da
          plataforma a cada ocorrência.
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          A empresa também passa a poder ser excluída pelo Admin Geral. Use apenas em contas internas
          de teste.
        </Typography>
      </Box>
    </ConfirmDialog>
  );
}

export default MarkCompanyTestDialog;
